<pt-details-layout
  [noDataMessage]="'LABELS.NO_SYSTEM_ADMINISTRATORS' | translate"
  [showNoData]="!administrators || administrators.length === 0"
  [showWarning]="noAdministratorFound"
  [title]="'LABELS.SYSTEM_ADMINISTRATORS' | translate"
  [warningMessage]="'MESSAGE.NO_ADMINISTRATOR' | translate"
>
  <ng-container body>
    <div (click)="openAdministrator(admin)"
         *ngFor="let admin of administrators"
         class="details-administrator-card">
      <pt-icon [key]='IconUser' [size]="24"></pt-icon>
      <div class="details-link">{{ admin.fullName }}</div>
    </div>
  </ng-container>
</pt-details-layout>
